import React from "react";
import { FadeUp } from "./FadeUp";
import { AppLink } from "../../../../components/ui/link";
import {
  PRODUCT_LANDING_DEFINITIONS,
  PRODUCT_LANDING_ORDER,
} from "../marketing/productLandingContent";

export const ProductsSection: React.FC = () => (
  <section
    id="products"
    className="py-24 bg-background"
    aria-labelledby="products-heading"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeUp>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2
            id="products-heading"
            className="text-3xl md:text-5xl font-bold text-foreground mb-6 tracking-tight font-display"
          >
            What $9 buys
          </h2>
          <div className="w-24 h-1.5 bg-premium-500 mx-auto mb-8 rounded-full" />
          <p className="text-xl text-muted-foreground font-medium">
            Use one or all three. Same $9.
          </p>
        </div>
      </FadeUp>

      <div className="grid md:grid-cols-3 gap-8">
        {PRODUCT_LANDING_ORDER.map((slug, index) => {
          const product = PRODUCT_LANDING_DEFINITIONS[slug];
          const Icon = product.kickerIcon;
          return (
            <FadeUp
              key={product.slug}
              delay={0.1 * (index + 1)}
              className="h-full"
            >
              <AppLink
                to={product.href}
                className="block h-full rounded-2xl text-inherit no-underline hover:text-inherit hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                <article className="relative h-full min-h-[28rem] overflow-hidden rounded-2xl border border-border shadow-xl group">
                  <img
                    src={product.image}
                    alt={product.imageAlt}
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    width={1600}
                    height={1067}
                    decoding="async"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-neutral-900 via-neutral-900/80 to-neutral-900/60" />
                  <div className="relative z-10 flex h-full min-h-[28rem] flex-col p-8 sm:p-10">
                    <span className="inline-flex w-fit items-center gap-2 rounded-full border border-premium-400/30 bg-premium-500/20 px-3 py-1 text-sm font-semibold uppercase tracking-wider text-premium-100 backdrop-blur-sm">
                      <Icon className="h-4 w-4" aria-hidden />
                      {product.kicker}
                    </span>
                    <div className="mt-auto pt-8">
                      <h3 className="font-display text-3xl font-bold text-white tracking-tight">
                        {product.name}
                      </h3>
                      <p className="mt-3 text-neutral-200 leading-relaxed font-light">
                        {product.cardDescription}
                      </p>
                      <ul className="mt-6 space-y-2">
                        {product.cardBullets.map((bullet) => (
                          <li
                            key={bullet}
                            className="text-sm font-medium text-white/90"
                          >
                            {bullet}
                          </li>
                        ))}
                      </ul>
                      <span className="mt-6 inline-flex text-sm font-semibold text-premium-300">
                        See {product.navLabel.toLowerCase()}
                      </span>
                    </div>
                  </div>
                </article>
              </AppLink>
            </FadeUp>
          );
        })}
      </div>
    </div>
  </section>
);
